<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="height"
    size="mini"
    resizable
    border
    row-id="orderPackingGoodsCode"
    :radio-config="{ highlight: true, trigger: 'click' }"
    :checkbox-config="{
      highlight: true,
      reserve: true,
      trigger: 'row',
    }"
    @checkbox-change="checkboxChange"
    @checkbox-all="checkboxChange"
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    height: { type: Number, default: 300 },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    choiceData() {
      return this.getCheckboxRecords()
    },
    getRadioRecord() {
      const data = this.$refs.vxeGrid.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid
        .getCheckboxRecords()
        .concat(this.$refs.vxeGrid.getCheckboxReserveRecords())
      if (!data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    changePopNum(num) {
      this.$emit('changePopNum', num)
    },
    checkboxChange() {
      let data = this.$refs.vxeGrid
        .getCheckboxRecords()
        .concat(this.$refs.vxeGrid.getCheckboxReserveRecords())
      if (!data || !data.length) {
        data = []
      }
      this.changePopNum(data.length)
    },
  },
}
</script>
